import React from 'react';
// import InfiniteCalendar from 'react-infinite-calendar';
import 'react-infinite-calendar/styles.css'; // Make sure to import the default stylesheet
// import ActivityTaskWidget
//   from '../../../components/ActivityTaskWidget/ActivityTaskWidget';
import NoteList from '../../../components/NoteList/NoteList';

import classes from './HomeView.scss';
import SimplCalendar from '../../../components/SimplCalendar/SimplCalendar';
// import HistoryList from '../../../components/HistoryList/HistoryList';
import Today from '../../../containers/Today';
import moment from 'moment';
import JoyRideDashboard from '../../../components/JoyRideDashboard/JoyRideDashboard';

export class HomeView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDay: moment().startOf('day'),
    };
  }

  changeDay = day => {
    // console.log(day);
    this.setState({
      selectedDay: moment(day),
    });
  };

  render() {
    return (
      <div className={classes.dashboard}>
        <div className="row">
          <div className="col-xs-12 col-sm-4 mobile-10">
            <SimplCalendar
              changeDay={day => this.changeDay(day)}
              day={this.state.selectedDay}
            />
            <NoteList />
          </div>
          <div className="col-xs-12 col-sm-8 mobile-1">
            <Today
              today={this.state.selectedDay}
              changeDay={day => this.changeDay(day)}
            />
          </div>
        </div>
        <JoyRideDashboard />
      </div>
    );
  }
}

export default HomeView;



// WEBPACK FOOTER //
// ./src/routes/Home/components/HomeView.js